import { useState } from 'react'

import { STRINGS, TABS } from '@/constants/businessModel'
import styles from '@/styles/BusinessModelTabs.module.css'

import ArrowButton from '../arrowButton'
import Carousel from '../carousel'

interface ButtonProps {
  label: string
  onClick: VoidFunction
  isActive: boolean
}

const Button = ({ label, onClick, isActive }: ButtonProps) => (
  <button
    onClick={onClick}
    role="tab"
    aria-selected={isActive}
    className={`py-2.5 px-4 rounded-sm mx-[5px] ${
      isActive
        ? `text-white ${styles.activeTab} bg-[#6bb51e]`
        : `text-[#495057] bg-transparent hover:bg-[#eeeeee] hover:text-[#1d1e22] ${styles.tab}`
    } transition-all duration-300`}
  >
    {label}
  </button>
)

const BusinessModelTabs = () => {
  const [activeTab, setActiveTab] = useState(0)

  const { heading, description, imageList, link } = TABS[activeTab]

  return (
    <>
      <header className="pt-8 mb-2.5 px-6">
        {TABS.map(({ heading, key }, index) => (
          <Button
            label={heading}
            onClick={() => setActiveTab(index)}
            key={key}
            isActive={activeTab === index}
          />
        ))}
      </header>
      <section className="pt-8 px-6">
        <h2 className="font-natosans-medium text-3xl my-2.5 text-black">
          {heading}
        </h2>
        <p className="pt-4 mb-2.5 text-footer-grey text-base">{description}</p>
        {link ? (
          <div className={`relative mb-2 group w-32 ${styles.readMore} pb-8`}>
            <span
              className={`group-hover:bg-[#6fbc1d] group-hover:w-full absolute top-0 left-0 h-8 ${styles.slider}`}
            />
            <ArrowButton label={STRINGS.READ_MORE} href={link} />
          </div>
        ) : null}
        {imageList ? (
          <Carousel
            imageList={imageList}
            aspectRatio={4 / 3}
            desktopImageCount={3}
            mobileImageCount={1}
          />
        ) : null}
      </section>
    </>
  )
}

export default BusinessModelTabs
